module.exports = __webpack_public_path__ + "img/logo.17244691.png";